<template>
  <div class="wrapper">
    <v-menu />
    <div class="content-box">
      <div class="content">
        <router-view/>
      </div>
    </div>
    <v-foot />
  </div>
</template>

<script>
	import vMenu from './menu.vue';
	import vFoot from './foot.vue';
	export default {
		components: {
			vMenu,
			vFoot,
		},
	};
</script>
<style>
  body {
    margin: 0px;
  }
</style>
